import React from 'react';
import CohortFilterValuesArray from './CohortFilterValuesArray';

const CohortFilterValuesNumbers = ({
  fieldType,
  filterUUID,
  saveErrors,
  values,
  disabled,
  onChange,
}) => (
  <CohortFilterValuesArray
    filterUUID={filterUUID}
    saveErrors={saveErrors}
    values={values}
    disabled={disabled}
    onChange={onChange}
    fieldType={fieldType}
    defaultValue=""
  />
);

export default CohortFilterValuesNumbers;
